exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mar-right {\r\n  margin-right: 10px\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/block-unblock-number/block-unblock-number.component.css
// module id = ../../../../../src/app/block-unblock-number/block-unblock-number.component.css
// module chunks = 0